module.exports = __webpack_public_path__ + "img/shusong4.ece15d28.jpg";